import React, { useState } from 'react';
// import WifiIcon from '../assets/wifi_icon.png';
import { ExportOutlined, FileAddOutlined, FilterOutlined, FlagOutlined, MenuOutlined, PlusCircleFilled, WifiOutlined } from '@ant-design/icons';
import AddAssetWhite from '../assets/CBSD.svg';
import { SMB_ICONS } from '../constants/IconConstants';
import { Building } from '../custom_icons/Building';
import AssetProps from '../interfaces/AssetProps';
import { generateWorkOrderId, getTechnology } from '../services/helper';
import AddAsset from './AddAssetCommon';
import { AddBuilding } from './AddBuilding/AddBuilding';
import { AddVenue } from './AddVenue/AddVenue';
import AssetDetails from './AssetDetails';
import { BuildingDetails } from './BuildingDetails/BuildingDetails';
import Calculate from './Calculate';
import CreateRfSimulation from './CreateRfSimulation';
import CreateWorkOrder from './CreateWorkOrder';
import { EditBuilding } from './EditBuilding/EditBuilding';
import { EditVenue } from './EditVenue/EditVenue';
import { FloorActions } from './FloorActions/FloorActions';
import { FloorDetails } from './FloorDetails/FloorDetails';
import './homeActions.css';
import ListBuildings from './ListBuildings';
import Measure from './Measure';
import './OutdoorRoutes.css';
import { VenueDetails } from './VenueDetails/VenueDetails';
import VenueList from './VenueList';
import ViewRfSimulation from './ViewRfSimulation';
import ViewWorkOrders from './ViewWorkOrders';
interface OutdoorRoutesProps {
  map: any;
  currentPage: string;
  setCurrentPage: (page: string) => void;
  addAssetClicked: (title: string, tech: string) => void;
  addVenueClicked: () => void;
  addBuildingClicked: () => void;
  measureClicked: () => void;
  calculateClicked: () => void;
  setCenter: (center: any) => void;
  showSearchLocation: (location: boolean) => void;
  assetDropLocation: any;
  getAssetsInBounds: (map: any) => void;
  changeMapForAzimuth: (isActive: boolean) => void;
  goToProfile: () => void;
  rmaNewSerialNumber: string[];
  setSelectedAsset: (asset: any) => void;
  assetEditAction: any;
  selectedAsset: any;
  calculateLocation: any;
  setCalculateLocation: (location: any) => void;
  getSingleAssetDetails: (trackingId: string) => void;
  setAssetEditAction: (action: any) => void;
  setRmaNewSerialNumber: (serialNumber: string[]) => void;
  setAssetDropLocation: (location: any) => void;
  center: any;
  setMeasurePoints: (points: any) => void;
  showMeasurePopup: (show: boolean) => void;
  setDetailsOfMeasure: (info: any) => void;
  measurePoints: any;
  assetsForMeasure: any;
  boundaryPolygon: google.maps.LatLng[] | undefined;
  emergencyBoundaryPolygon: google.maps.LatLng[] | undefined;
  setBoundaryDrawMode: (mode: 'draw' | null) => void;
  cancelBoundaryDraw: () => void;
  // setBoundaryColor: (color: string) => void;
  // boundaryColor: string;
  setCurrentVenueId: (id: string) => void;
  venueId: string;
  setBuildingsForVenue: (buildings: any) => void;
  setBuildingId: (buildingId: string) => void;
  buildingId: string;
  setFloorId: (floorId: string) => void;
  floorId: string;
  venuesOnMap: any;
  buildingsOnMap: any;
  assetsInBounds: any[];
  fitVenueOnMap: () => void;
  setFloorGeoJSON: (geoJSON: any) => void;
  setFloorGeoJSONUrl: (url: string) => void;
  panToBuilding: (buildingId: string) => void;
  unsetFloorGeoJSON: () => void;
  setShowControls: any;
  getRFAnalysis: (latlng: string) => void;
  // setBuildingBoundaryColor : (color  :string) => void
  // buildingBoundaryColor : string;
  // buildingBoundaryPolygon : google.maps.LatLng[] | undefined;
  addSiteToWorkOrder: () => void;
  cancelWorkOrderCreation: () => void;
  mapAssetFilters: any[];
  changeMapAssetFilter: (val: string) => void;
  getBuildingPolygons: (lat: number, lng: number) => void;
  setIsEmergency: (val: boolean) => void;
  selectedFloor: any;
  setSelectedFloor: (val: any) => void;
  selectedTechnology: string;
  runMultipleRFAnalysis: () => void;
  rfAnalysisForm: any;
  setRfAnalysisForm: (form: any) => void;
  showRfAnalysis: boolean;
  setShowRfAnalysis: (value: boolean) => void;
  showRfRadius: boolean;
  setShowRfRadius: (value: boolean) => void;
  setRfLocation: (location: any) => void;
  setWorkOrderId: (id: string) => void;
  title: string;
  currentSelectedTechnology: string;
  assets: any[];
  cancelRfSimulation: () => void;
  rfResults: any;
  rfParameters: any;
  rfImageUrl: string;
  rfBounds: any;
  rfLocation: any;
  showRfSimulations: () => void;
  setRfResults: (results: any) => void;
  setRfParameters: (parameters: any) => void;
  setRfImageUrl: (url: string) => void;
  setRfBounds: (bounds: any) => void;
  isPlacingWorkOrder: boolean;
  setIsPlacingWorkOrder: (value: boolean) => void;
  totalServiceDrops: any[];
  setTotalServiceDrops: (value: any[]) => void;
  setRFImageUrl: (url: string) => void;
  setRFBounds: (bounds: any) => void;
  isEmergency: boolean;
  building: any;
  setBuilding: (building: any) => void;
  setVenueBoundaryPath: (venueBoundary: google.maps.LatLng[]) => void;
  setHiddenVenueId: (id: string) => void;
  setWorkOrderVenueId: (id: any) => void;
  setWorkOrderBuildingId: (id: any) => void;
  viewRFPathAnalysis: boolean;
  setViewRFPathAnalysis: (value: boolean) => void;
  setDrawMode: (mode: any) => void;
  drawMode: any;
  cancelEmergencyDrawing: () => void;
  showActionPanel: boolean;
  setShowActionPanel: (value: boolean) => void;
}

const OutdoorRoutes: React.FC<OutdoorRoutesProps> = ({
  currentPage,
  setCurrentPage,
  addAssetClicked,
  addVenueClicked,
  addBuildingClicked,
  measureClicked,
  calculateClicked,
  map,
  setCenter,
  showSearchLocation,
  assetDropLocation,
  getAssetsInBounds,
  changeMapForAzimuth,
  goToProfile,
  rmaNewSerialNumber,
  setSelectedAsset,
  assetEditAction,
  selectedAsset,
  calculateLocation,
  setCalculateLocation,
  getSingleAssetDetails,
  setAssetEditAction,
  setRmaNewSerialNumber,
  setAssetDropLocation,
  center,
  setMeasurePoints,
  showMeasurePopup,
  setDetailsOfMeasure,
  assetsForMeasure,
  measurePoints,
  boundaryPolygon,
  emergencyBoundaryPolygon,
  setBoundaryDrawMode,
  cancelBoundaryDraw,
  // setBoundaryColor,
  // boundaryColor,
  setCurrentVenueId,
  venueId,
  setBuildingsForVenue,
  setBuildingId,
  buildingId,
  setFloorId,
  floorId,
  venuesOnMap,
  assetsInBounds,
  fitVenueOnMap,
  setFloorGeoJSON,
  setFloorGeoJSONUrl,
  panToBuilding,
  unsetFloorGeoJSON,
  // setBuildingBoundaryColor ,
  // buildingBoundaryColor ,
  // buildingBoundaryPolygon
  setShowControls,
  getRFAnalysis,
  addSiteToWorkOrder,
  cancelWorkOrderCreation,
  mapAssetFilters,
  changeMapAssetFilter,
  getBuildingPolygons,
  setIsEmergency,
  setSelectedFloor,
  selectedFloor,
  selectedTechnology,
  runMultipleRFAnalysis,
  rfAnalysisForm,
  setRfAnalysisForm,
  showRfAnalysis,
  setShowRfAnalysis,
  showRfRadius,
  setShowRfRadius,
  setRfLocation,
  setWorkOrderId,
  title,
  currentSelectedTechnology,
  buildingsOnMap,
  assets,
  cancelRfSimulation,
  rfResults,
  rfParameters,
  rfImageUrl,
  rfBounds,
  rfLocation,
  showRfSimulations,
  setRfResults,
  setRfParameters,
  setRfImageUrl,
  setRfBounds,
  isPlacingWorkOrder,
  setIsPlacingWorkOrder,
  totalServiceDrops,
  setTotalServiceDrops,
  setRFImageUrl,
  setRFBounds,
  isEmergency,
  building,
  setBuilding,
  setVenueBoundaryPath,
  setHiddenVenueId,
  setWorkOrderVenueId,
  setWorkOrderBuildingId,
  viewRFPathAnalysis,
  setViewRFPathAnalysis,
  setDrawMode,
  drawMode,
  cancelEmergencyDrawing,
  setShowActionPanel,
  showActionPanel,
}) => {
  const [floorActionType, setFloorActionType] = useState('');
  const [openList, setOpenList] = useState('');
  const [buildingNavigation, setBuildingNavigation] = useState('');
  const [preloadConfirmVisible, setPreloadConfirmVisible] = useState(false);
  const [isViewSimulation, setIsViewSimulation] = useState(false);
  const handleAddSiteToWorkOrder = () => {
    setPreloadConfirmVisible(false);
    addSiteToWorkOrder();
  };

  let technologyType = getTechnology() || '';

  const getIconForAsset = () => {
    if (technologyType == 'cbrs_5g') return <img src={AddAssetWhite} className="h-20 me-2" />;
    else if (technologyType == 'wifi_6e' || technologyType == 'tarana') return <WifiOutlined className="me-2" style={{ color: '#fff' }} />;
  };

  const getLabelForAsset = () => {
    if (technologyType == 'cbrs_5g') return 'Base Station';
    else if (technologyType == 'wifi_6e') return 'AP';
    else if (technologyType == 'tarana') return 'Base Node';
  };

  const functionCallonClick = () => {
    if (technologyType == 'cbrs_5g') addAssetClicked('Base Station', 'cbrs_5g');
    else if (technologyType == 'wifi_6e') addAssetClicked('AP', 'Wifi');
    else if (technologyType == 'tarana') addAssetClicked('Base Node', 'tarana');
  };

  return (
    <>
      {!['assetDetails', 'workOrderCreation', 'viewRfSimulation', 'viewWorkOrders', 'createRfSimulation'].includes(currentPage) && (
        <div className="position-absolute">
          <div className="app-card-main mx-3 mt-3">
            <div className="row g-2 vertical-center row-wise">
              <div className="row-wise col vertical-center">
                <div className="p-2 vertical-center center">
                  <MenuOutlined
                    onClick={() => {
                      setOpenList((list) => {
                        if (list == 'other_installations') return '';
                        else return 'other_installations';
                      });
                    }}
                    className="me-2 text-color"
                  />
                </div>
                <div className={' p-2 center' + openList == 'venue' ? 'border-blue' : 'border'}>
                  <div className="dropstart">
                    {/* <a
                      href="#"
                      role="button"
                      id="dropdownMenuLinkMapFilter"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{ color: 'transparent' }}> */}
                    {/* <div title="Filter by" className="map-icon-background mb-3">
                                    <span className="material-icons-outlined map-icon">visibility</span>
                                  </div> */}
                    <FilterOutlined
                      onClick={
                        () => {}
                        // setOpenList((list) => {
                        //   if (list == 'filter_map') return '';
                        //   else return 'filter_map';
                        // })
                      }
                      className="text-color"
                    />
                    {/* </a> */}
                  </div>
                </div>
                <div className="divider-vertical"></div>
                <div
                  onClick={() =>
                    setOpenList((list) => {
                      if (list == 'venue') return '';
                      else return 'venue';
                    })
                  }
                  className={' p-2 center' + openList == 'venue' ? 'border-blue' : 'border'}>
                  <PlusCircleFilled className={openList == 'venue' ? 'primary-blue' : 'text-color'} />
                </div>
                <div className="divider-vertical"></div>

                <div className="action-box px-2 center vertical-center" onClick={functionCallonClick}>
                  {getIconForAsset()}
                  <label className="action-label">{getLabelForAsset()}</label>
                </div>

                <div
                  className="ms-2 action-box px-2 center"
                  onClick={() =>
                    addAssetClicked(
                      technologyType === 'tarana' ? 'Remote Node' : 'CPE',
                      technologyType === 'tarana' ? 'tarana_cpe' : technologyType === 'wifi_6e' ? 'cpe_wifi' : 'cpe_cbsd'
                    )
                  }>
                  <img src={SMB_ICONS['Field Tech White']} className="h-20 me-2" />
                  <span className="action-label">{technologyType == 'tarana' ? 'Remote Node' : 'CPE'}</span>
                </div>
              </div>
            </div>

            {/* {!['engineer', 'cpi', 'installer', null].includes(getRole()) && getOrganisationId() !== 1 ? (
          <div className="action-box ps-1 pe-1 center mt-2" onClick={addVenueClicked}>
            <span className="material-icons-outlined me-2" style={{ color: '#0059b2' }}>
              pin_drop
            </span>
            <span className="action-label">{'Venue'}</span>
          </div>
        ) : (
          <></>
        )}

        <hr className="" style={{ borderTop: '3px solid #ccc' }}></hr>
        <span className="home-action-heading">Utility</span>
        <div className="row gx-2 mt-2">
          <div className="col-6">
            <HomeActions label="Measure" action="measure" clicked={measureClicked} />
          </div>
          <div className="col-6">
            <HomeActions label="Calculate" action="calculate" clicked={calculateClicked} />
          </div>
        </div>*/}
          </div>
          {openList === 'venue' && (
            <div className="app-card-main mx-3 my-1 col-wise ps-2 cursor-pointer">
              <ListBuildings
                titleClassName="text-color"
                routePage="addVenue"
                setCurrentPage={() => {
                  addVenueClicked();
                  setOpenList('');
                }}
                title="Venue"
                desc="Specific place which can include more buildings"
                icon={<FlagOutlined className="text-color pe-2" />}
              />
              <ListBuildings
                titleClassName="text-color"
                routePage="addBuilding"
                setCurrentPage={() => {
                  // setCurrentPage('addBuilding');
                  addBuildingClicked();
                  setOpenList('');
                  setBuildingNavigation('home');
                }}
                title="Building"
                desc="Specific place which can have floors"
                icon={<Building className="text-color pe-2" />}
              />
              <div className="divider-horizontal"></div>
              <ListBuildings
                className="vertical-center"
                titleColor="#1677FF"
                height={'32px'}
                title="Open Design Studio"
                desc=""
                icon={<ExportOutlined className="primary-blue pe-2" />}
              />
            </div>
          )}
          {/*  {openList == 'filter_map' && (
            <div className="app-card-main mx-3 my-1 col-wise ps-2 cursor-pointer" style={{ width: '200px', marginLeft: '25px' }}>
              <ul className=" px-3 py-2" style={{ width: '200px' }}>
                {legendTechDisplay.map((item) => {
                  return (
                    <li onClick={() => changeMapAssetFilter(item['value'])} className="row-wise mt-2 vertical-center">
                      <Checkbox checked={mapAssetFilters.includes(item['value'])} />
                      <span className="legend-details ms-3">{item.label}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
          )} */}
          {openList == 'other_installations' && (
            <div className="app-card-main mx-3 my-1 col-wise ps-2 cursor-pointer" style={{ width: '250px', marginLeft: '25px' }}>
              <ul className=" px-3 " style={{ width: '250px' }}>
                <li
                  onClick={() => {
                    setCurrentPage('viewWorkOrders');
                    setOpenList('');
                    setAssetDropLocation({ lat: map?.getCenter()?.lat(), lng: map?.getCenter()?.lng() });
                    setWorkOrderId(generateWorkOrderId() || '');
                  }}
                  className="row-wise mt-2 vertical-center">
                  <FileAddOutlined className="text-color ms-1 pe-1" />
                  <span className="legend-details ms-2">Work Order</span>
                </li>
                <li
                  onClick={() => {
                    setCurrentPage('viewRfSimulation');
                    setOpenList('');
                    setAssetDropLocation({ lat: map?.getCenter()?.lat(), lng: map?.getCenter()?.lng() });
                    setRfLocation({ lat: map?.getCenter()?.lat(), lng: map?.getCenter()?.lng() });
                  }}
                  className="row-wise mt-2 vertical-center">
                  <WifiOutlined className="text-color ms-1 pe-1" />
                  <span className="legend-details ms-2">RF Simulation</span>
                </li>
                <li
                  onClick={() => {
                    setCurrentPage('viewVenues');
                    setOpenList('');
                  }}
                  className="row-wise mt-2 vertical-center">
                  <FlagOutlined className="text-color ms-1 pe-1" />
                  <span className="legend-details ms-2">Venues</span>
                </li>
              </ul>
            </div>
          )}
        </div>
      )}
      {currentPage == 'viewVenues' && (
        <VenueList
          goBack={(page: string) => {
            setCurrentPage(page);
            getAssetsInBounds(map);
          }}
          onVenueSelected={(venue_id: string, location: { lat: number; lng: number }, boundsPolygon: any[]) => {
            setCurrentVenueId(venue_id);
            setCurrentPage('venueDetails');
            setAssetDropLocation({ lat: location.lat, lng: location.lng });
            map?.setZoom(20);
            map?.setCenter({ lat: location.lat, lng: location.lng });
            if (boundsPolygon?.length > 0 && map) {
              const bounds = new window.google.maps.LatLngBounds();
              boundsPolygon.forEach((point: any) => {
                bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
              });
              map.fitBounds(bounds);
            }
            getAssetsInBounds(map);
          }}
        />
      )}
      {currentPage == 'viewRfSimulation' && (
        <ViewRfSimulation
          close={() => cancelRfSimulation()}
          createNewSimulation={() => setCurrentPage('createRfSimulation')}
          viewSimulation={(simulation: any) => {
            setCurrentPage('createRfSimulation');
            setIsViewSimulation(true);
            setRfAnalysisForm(simulation.user_selections);
            setRfResults(simulation.rf_results);
            setRfParameters(simulation.rf_parameters);
            setRfImageUrl(simulation.rf_image_url);
            setRfBounds(simulation.rf_bounds);
            setRfLocation({ lat: simulation.location.latitude, lng: simulation.location.longitude });
            setAssetDropLocation({ lat: simulation.location.latitude, lng: simulation.location.longitude });
            setCenter({ lat: simulation.location.latitude, lng: simulation.location.longitude });
          }}
        />
      )}
      {currentPage == 'createRfSimulation' && (
        <CreateRfSimulation
          isViewSimulation={isViewSimulation}
          goBack={() => {
            showRfSimulations();
          }}
          showRfAnalysis={showRfAnalysis}
          setShowRfAnalysis={setShowRfAnalysis}
          rfAnalysisForm={rfAnalysisForm}
          setRfAnalysisForm={setRfAnalysisForm}
          showRfRadius={showRfRadius}
          setShowRfRadius={setShowRfRadius}
          runMultipleRFAnalysis={runMultipleRFAnalysis}
          assets={assets}
          rfResults={rfResults}
          rfParameters={rfParameters}
          rfImageUrl={rfImageUrl}
          rfBounds={rfBounds}
          rfLocation={rfLocation}
        />
      )}
      {currentPage == 'workOrderCreation' && (
        <CreateWorkOrder
          cancelEmergencyDrawing={cancelEmergencyDrawing}
          setDrawMode={setDrawMode}
          drawMode={drawMode}
          getAssetsInBounds={() => getAssetsInBounds(map)}
          isEmergency={isEmergency}
          setIsEmergency={setIsEmergency}
          setRFImageUrl={setRFImageUrl}
          setRFBounds={setRFBounds}
          isPlacingWorkOrder={isPlacingWorkOrder}
          setIsPlacingWorkOrder={setIsPlacingWorkOrder}
          cancelWorkOrderCreation={cancelWorkOrderCreation}
          setPreloadConfirmVisible={setPreloadConfirmVisible}
          totalServiceDrops={totalServiceDrops}
          setTotalServiceDrops={setTotalServiceDrops}
          preloadConfirmVisible={preloadConfirmVisible}
          venuesOnMap={venuesOnMap}
          buildingsOnMap={buildingsOnMap}
          position={assetDropLocation}
          setWorkOrderVenueId={setWorkOrderVenueId}
          setWorkOrderBuildingId={setWorkOrderBuildingId}
          emergencyBoundaryPolygon={emergencyBoundaryPolygon}
        />
      )}
      {currentPage == 'viewWorkOrders' && (
        <ViewWorkOrders close={() => setCurrentPage('home')} createWorkOrder={() => setCurrentPage('workOrderCreation')} isEmergency={isEmergency} />
      )}
      {currentPage === 'addAssetCommon' ? (
        <AddAsset
          goBack={(page: string) => {
            setCurrentPage(page);
            getAssetsInBounds(map);
          }}
          position={assetDropLocation}
          azimuthActivity={(isActive: boolean) => {
            changeMapForAzimuth(isActive);
          }}
          goToProfile={() => {
            goToProfile();
          }}
          venuesOnMap={venuesOnMap}
          setFloorGeoJSONUrl={setFloorGeoJSONUrl}
          unsetFloorGeoJSON={unsetFloorGeoJSON}
          setVenueId={setCurrentVenueId}
          setBuildingId={setBuildingId}
          setFloorId={setFloorId}
          selectedFloor={selectedFloor}
          setSelectedFloor={setSelectedFloor}
          title={title}
          currentSelectedTechnology={currentSelectedTechnology}
          action="Add"
          buildingsOnMap={buildingsOnMap}
          selectedBuilding={building}
          setSelectedBuilding={setBuilding}
          setAssetDropLocation={setAssetDropLocation}
        />
      ) : currentPage === 'editAsset' ? (
        <AddAsset
          rmaSerialNumber={rmaNewSerialNumber}
          goBack={(page: string) => {
            setCurrentPage(page);
            setSelectedAsset(undefined);
            getAssetsInBounds(map);
          }}
          action={assetEditAction}
          position={assetDropLocation}
          assetDetails={selectedAsset}
          azimuthActivity={(isActive: boolean) => {
            changeMapForAzimuth(isActive);
          }}
          goToProfile={() => {
            goToProfile();
          }}
          setFloorGeoJSONUrl={setFloorGeoJSONUrl}
          unsetFloorGeoJSON={unsetFloorGeoJSON}
          setBuildingId={setBuildingId}
          setFloorId={setFloorId}
          venuesOnMap={venuesOnMap}
          setVenueId={setCurrentVenueId}
          currentSelectedTechnology={currentSelectedTechnology}
          selectedFloor={selectedFloor}
          setSelectedFloor={setSelectedFloor}
          title={title}
          buildingsOnMap={buildingsOnMap}
          selectedBuilding={building}
          setSelectedBuilding={setBuilding}
          setAssetDropLocation={setAssetDropLocation}
        />
      ) : currentPage === 'calculate' ? (
        <Calculate
          goBack={(page: string) => {
            setCurrentPage(page);
          }}
          latitude={calculateLocation.lat}
          longitude={calculateLocation.lng}
          setLatitude={(value: string) => {
            setCalculateLocation({ lat: value, lng: calculateLocation.lng });
            setCenter({ lat: parseFloat(value), lng: parseFloat(calculateLocation.lng) });
          }}
          setLongitude={(value: string) => {
            setCalculateLocation({ lat: calculateLocation.lat, lng: value });
            setCenter({ lat: parseFloat(calculateLocation.lat), lng: parseFloat(value) });
          }}
        />
      ) : currentPage === 'assetDetails' ? (
        <AssetDetails
          getBuildingPolygons={getBuildingPolygons}
          setUpdatedAsset={(asset: AssetProps) => {
            setSelectedAsset(asset);
          }}
          refreshAsset={(trackingId: string) => {
            getSingleAssetDetails(trackingId);
            getAssetsInBounds(map);
          }}
          setAction={(action: string) => {
            setAssetEditAction(action);
          }}
          rmaSerialNumber={(value: string[]) => {
            setRmaNewSerialNumber(value);
          }}
          goBack={(page: string) => {
            setCurrentPage(page);
            getAssetsInBounds(map);
            if (page === 'home') {
              setSelectedAsset(undefined);
            } else if (page === 'addAssetCommon' && selectedAsset?.asset.status !== 'SAS') {
              setAssetDropLocation(center);
            }
          }}
          getRFAnalysis={(asset_id) => {
            getRFAnalysis(asset_id);
          }}
          asset={selectedAsset}
          viewRFPathAnalysis={viewRFPathAnalysis}
          setViewRFPathAnalysis={setViewRFPathAnalysis}
          setShowActionPanel={setShowActionPanel}
          showActionPanel={showActionPanel}
        />
      ) : currentPage === 'measure' ? (
        <Measure
          goBack={(page: string) => {
            setCurrentPage(page);
            setMeasurePoints([]);
            showMeasurePopup(false);
          }}
          assetsForMeasure={assetsForMeasure}
          measurePoints={measurePoints}
          setInfoPopup={(info: any) => {
            setDetailsOfMeasure(info);
          }}
        />
      ) : currentPage === 'addVenue' ? (
        <AddVenue
          navigateTo={(page: string) => {
            setCurrentPage(page);
            getAssetsInBounds(map);
          }}
          position={assetDropLocation}
          boundaryPolygon={boundaryPolygon}
          setBoundaryDrawMode={setBoundaryDrawMode}
          cancelBoundaryDraw={cancelBoundaryDraw}
          // setBoundaryColor={setBoundaryColor}
          // boundaryColor={boundaryColor}
          setCurrentVenueId={setCurrentVenueId}
          assetsInBounds={assetsInBounds}
          fitVenueOnMap={fitVenueOnMap}
          venuesOnMap={venuesOnMap}
        />
      ) : currentPage === 'venueDetails' ? (
        <VenueDetails
          navigateTo={(page: string) => {
            setCurrentPage(page);
            getAssetsInBounds(map);
          }}
          venueId={venueId}
          setBuildingsForVenue={setBuildingsForVenue}
          setBuildingId={setBuildingId}
          setBuildingNavigation={setBuildingNavigation}
        />
      ) : currentPage === 'editVenue' ? (
        <EditVenue
          navigateTo={(page: string) => {
            setCurrentPage(page);
            getAssetsInBounds(map);
          }}
          venueId={venueId}
          setBoundaryDrawMode={setBoundaryDrawMode}
          setVenueBoundaryPath={setVenueBoundaryPath}
          setHiddenVenueId={setHiddenVenueId}
          position={assetDropLocation}
          boundaryPolygon={boundaryPolygon}
        />
      ) : currentPage === 'addBuilding' ? (
        <AddBuilding
          navigateTo={(page: string) => {
            setCurrentPage(page);
          }}
          position={assetDropLocation}
          venueId={venueId}
          setBoundaryDrawMode={setBoundaryDrawMode}
          cancelBoundaryDraw={cancelBoundaryDraw}
          // setBoundaryColor={setBuildingBoundaryColor}
          // boundaryColor={buildingBoundaryColor}
          boundaryPolygon={boundaryPolygon}
          assetsInBounds={assetsInBounds}
          fitVenueOnMap={fitVenueOnMap}
          navigateFrom={buildingNavigation}
          setBuildingId={setBuildingId}
        />
      ) : currentPage === 'buildingDetails' ? (
        <BuildingDetails
          navigateTo={(page: string) => {
            setCurrentPage(page);
          }}
          building={building}
          setBuilding={setBuilding}
          buildingId={buildingId}
          setFloorId={setFloorId}
          floorId={floorId}
          setFloorActionType={setFloorActionType}
          setSelectedFloor={setSelectedFloor}
          venueId={venueId}
          assets={assetsInBounds}
          setBuildingId={setBuildingId}
        />
      ) : currentPage === 'editBuilding' ? (
        <EditBuilding
          buildingId={buildingId}
          navigateTo={(page: string) => {
            setCurrentPage(page);
          }}
          boundaryPolygon={boundaryPolygon}
          setBoundaryDrawMode={setBoundaryDrawMode}
          cancelBoundaryDraw={cancelBoundaryDraw}
          setVenueBoundaryPath={setVenueBoundaryPath}
          assets={assetsInBounds}
        />
      ) : currentPage === 'floorActions' ? (
        <FloorActions
          floorId={floorId}
          buildingId={buildingId}
          navigateTo={(page: string) => {
            setCurrentPage(page);
          }}
          floorActionType={floorActionType}
          position={assetDropLocation}
          setFloorGeoJSON={setFloorGeoJSON}
          setShowControls={setShowControls}
          venueId={venueId}
        />
      ) : (
        currentPage === 'floorDetails' && (
          <FloorDetails
            floorId={floorId}
            buildingId={buildingId}
            navigateTo={(page: string) => {
              setCurrentPage(page);
            }}
            setFloorId={setFloorId}
            setFloorActionType={setFloorActionType}
            position={assetDropLocation}
            setFloorGeoJSONUrl={setFloorGeoJSONUrl}
          />
        )
      )}
      {/* {['buildingDetails', 'floorDetails'].includes(currentPage) && <LevelSelectorGeoJson floorDetails={selectedFloor} />} */}
    </>
  );
};

export default OutdoorRoutes;
